/* Version: 3.5.149 */
'use client';
import { Caution } from '@manulife/mux-cds-icons';
import styled from 'styled-components';
import { rem } from '../../utils/functions.js';
import { typography } from '../../typography/typography.js';

var ErrorIcon = /*#__PURE__*/styled(Caution).withConfig({
  displayName: "styledComponents__ErrorIcon",
  componentId: "sc-5pv5vu-0"
})(["color:", ";flex-shrink:0;height:", ";width:", ";min-width:", ";min-height:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colorPalette.utilityColors.error;
}, rem(24), rem(24), rem(24), rem(24));
var ErrorMsg = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__ErrorMsg",
  componentId: "sc-5pv5vu-1"
})(["color:", ";font-family:", ";font-size:", ";font-weight:", ";line-height:", ";margin:0;margin-top:0.5em;text-align:left;width:var(--errors-width);a{color:", ";font-weight:bold;}", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colorPalette.utilityColors.error;
}, typography.fontFamily, typography.fontSize, typography.fontWeightNormal, typography.lineHeight, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colorPalette.utilityColors.error;
}, function (_ref4) {
  var rootStyle = _ref4.rootStyle;
  return rootStyle;
});
process.env.NODE_ENV !== "production" ? ErrorMsg.displayName = 'ErrorMsg' : undefined;

export { ErrorIcon, ErrorMsg };
